import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { AllEmpService } from 'src/app/hrms/service/all-emp.service';
import { session } from 'src/environments/environment.session';
import Swal from 'sweetalert2';
import { ClerkNocService } from '../service/clerk-noc.service';
import { MainService } from 'src/app/emb/service/main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditorService } from 'src/app/md/service/editor.service';
import { MatTableDataSource } from '@angular/material/table';
import { ApprovalUserService } from 'src/app/portal/service/approval-user.service';
import { MainService as portalmainservice } from '../../portal/service/main.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
declare var $: any

@Component({
  selector: 'app-accountant',
  templateUrl: './accountant.component.html',
  styleUrls: ['./accountant.component.css']
})
export class AccountantComponent {
  page_flag: boolean = true;
  bill_flag: boolean = false
  list_flag: boolean = true
  ebillUser: any
  fourth: any;
  second: any;
  third: any;
  isLinear: any;
  first: any;
  show = false
  Obj: any
  b_acct_id: any
  datasource: any;
  datasource_verfyed: any;
  create_flag: boolean = false
  UserObj: any
  notesheet_desc: any = []
  role: any;
  status: any;
  flag_status: any;
  displayedColumns: any = ['si_no', 'applicant_name', 'file_number', 'letter_number', 'Date', 'trans_id', 'status', 'bill_amount', 'action'];
  constructor(public portalmainservice: portalmainservice, public ApprovalUserService: ApprovalUserService, private allEmpService: AllEmpService, private toastr: ToastrService, public clerkNocService: ClerkNocService, private mainserviceEmb: MainService, public spinner: NgxSpinnerService, private editorService: EditorService,) { }
  logObj = { component: 'accountant' }
  @ViewChild('paginator0', { static: false }) paginator0!: MatPaginator;
  @ViewChild('sortCol0', { static: false }) sortCol0!: MatSort;

  @ViewChild('paginator0', { static: false }) paginator1!: MatPaginator;
  @ViewChild('sortCol0', { static: false }) sortCol1!: MatSort;

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id;
    await this.getallpaymentdata();
    await this.getnode_cd()
    await this.getallworkflowuser()
    for (let i = 0; i < this.ebillUser.role_cd.length; i++) {
      if (this.role_cdArr.includes(this.ebillUser.role_cd[i])) {




        this.role = this.ebillUser.role_cd[i];
        console.log(this.role);

        // this.status = "ASSIGN_" + this.role;
        this.status = "ASSIGN_"
        this.flag_status = "ASSIGN_" + this.role

        // break; // Exit the loop if a matching role is found
      }

    }

  }

  role_cdArr: any = []
  AllWorkFlow_Data: any = []
  async getallworkflowuser() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    obj["doc_type"] = ['ACCOUNTANT']
    obj["module_cd"] = 'NOC'

    obj["status"] = 'ACTIVE'

    let resp = await this.clerkNocService.getallworkflowuser(JSON.stringify(obj))
    console.log(resp)
    if (resp["error"] == false) {
      this.role_cdArr = []
      this.AllWorkFlow_Data = []
      this.AllWorkFlow_Data = resp.data
      this.role_cdArr = resp.data.map((item: { role_cd: any; }) => item.role_cd)
      console.log(this.AllWorkFlow_Data);

    }
  }

  async getallpaymentdata() {

    var obj: any = Object()
    obj['b_acct_id'] = this.ebillUser.b_acct_id
    obj['user_id'] = this.ebillUser.user_id
    obj['status'] = 'SUCCESS'
    // obj["role"] = this.role
    var resp = await this.clerkNocService.getallpaymentdata(JSON.stringify(obj))
    if (resp['error'] == false) {

    
    } else {
      Swal.fire("Error", resp['data'], 'error');
    }
    let succesdata = []
    succesdata = resp['data'].filter((item: any) => item.bill_status == 'BILL_PAID')
    let k = 1
    for (let i = 0; i < succesdata.length; i++) {
      succesdata[i]['new_index'] = k
      k = k + 1
    }
    this.datasource = new MatTableDataSource(succesdata)
    this.datasource.paginator = this.paginator0;
    this.datasource.sort = this.sortCol0;
    let verifyeddata = []
    verifyeddata = resp['data'].filter((item: any) => item.bill_status == 'VERIFYED')
    this.datasource_verfyed = new MatTableDataSource(verifyeddata)
    this.datasource_verfyed.paginator = this.paginator1;
    this.datasource_verfyed.sort = this.sortCol1;
  }

  send_to_ctp(element: any) {

    this.Obj = {}

    this.create_flag = true;
    this.list_flag = false;
    this.page_flag = true
    this.Obj = element
    console.log(this.Obj)

  }

  back() {
    this.create_flag = false;
    this.list_flag = true;
    this.page_flag = true
  }

  supp_doc: any

  view_correspondence(element: any) {

  }

  appr_remark: any
  forwarded_user_id: any;

  async submit() {

    this.appr_remark = null
    this.forwarded_user_id = null
    this.Obj['level'] = 1
    this.Obj['branch'] = 1
    this.Obj['doc_local_no'] = this.Obj['file_id']

    this.Obj['doc_type'] = 'ACCOUNTANT'

    this.Obj['node_cd'] = this.Obj['node_cd'] !== undefined ? this.Obj['node_cd'] : this.node_code[0];

    this.Obj['module_cd'] = 'NOC';
    // this.Obj['node_cd'] = this.node_code

    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, this.Obj['doc_type'], 'NOC');
    console.log(this.ApprovalUserService.workflow_level1);

    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.Obj['doc_local_no'], 'VERIFYED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.Obj)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.Obj)
    /* await this.getAllRule();
    await this.getundertakings(element); */
    $('#myModal3').modal('show');

  }

  node_code: any = []
  async getnode_cd() {
    let obj: any = {}
    this.node_code = []
    obj["b_acct_id"] = this.b_acct_id;
    obj["user_id"] = this.ebillUser.user_id
    obj["status"] = 'ACTIVE'
    let resp = await this.clerkNocService.getnode_cd(JSON.stringify(obj))
    console.log(resp);
    if (resp["error"] == false) {
      this.node_code = resp['data'].map((item: { node_cd: any; }) => item.node_cd)
    }
  }



  undertakings: any = []
  message_flag: any = false
  async send_for_billing() {





    this.appr_remark = null
    this.forwarded_user_id = null
    this.Obj['level'] = 1
    this.Obj['branch'] = 1
    this.Obj['doc_local_no'] = this.Obj['file_id']

    this.Obj['doc_type'] = 'ACCOUNTANT'

    this.Obj['node_cd'] = this.Obj['node_cd'] !== undefined ? this.Obj['node_cd'] : this.node_code[0];

    this.Obj['module_cd'] = 'NOC';
    // this.Obj['node_cd'] = this.node_code

    await this.ApprovalUserService.getWorkflowlog(this.ebillUser, this.Obj['doc_type'], 'NOC');
    console.log(this.ApprovalUserService.workflow_level1);

    if (this.ApprovalUserService.workflow_level1 == undefined) {
      // await this.ChangestatusSalBill(this.Obj['doc_local_no'], 'VERIFYED')
      return;
    }
    await this.ApprovalUserService.getMostLatestWorkflowlog(this.ebillUser, this.Obj)
    await this.ApprovalUserService.getWorkflowloguser(this.ebillUser, this.Obj)
    /* await this.getAllRule();
    await this.getundertakings(element); */
    $('#myModal3').modal('show');
  }

  isResponseReceived: boolean = false;
  // level1 = {};
  async Approvedapproval() {
    this.spinner.show()

    let obj: any = {}
    obj['doc_type'] = 'ACCOUNTANT'
    obj['doc_local_no'] = this.Obj['file_id']
    obj['module_cd'] = 'NOC'
    obj["b_acct_id"] = this.b_acct_id
    let status = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd'];
    let resp1 = await this.clerkNocService.getworkflowloguser(JSON.stringify(obj))
    if (resp1["error"] == false) {
      if (resp1.data.length == 0) {

        this.isResponseReceived = true
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          let obb: any = new Object();

          obb['user_id'] = this.ebillUser.user_id
          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.appr_remark
          obb['remark'] = this.appr_remark
          obb['status'] = 'VERIFYED'
          obb['doc_type'] = 'ACCOUNTANT'

          // if (this.clerk_flag == true) {

          //   obb['doc_type'] = 'CTP'

          //   status = 'ASSINGED_CTP'
          // } else if (this.eng_Dept_flag == true) {
          //   // obb['doc_type'] = 'ENGINEERING'

          //   status = this.status
          //   this.Obj = this.alltabledata

          // }
          obb['doc_local_no'] = this.Obj['file_id']
          obb['doc_desc'] = `This Filid NO ${this.Obj['file_id']} Is Assigned to CTP`
          // obb['role_cd'] = this.ApprovalUserService.level1['role_cd']//this.level1['role_cd']
          obb['role_cd'] = this.role//this.level1['role_cd']

          obb['module_cd'] = 'NOC'
          obb['node_cd'] = this.node_code
          obb['level'] = this.ApprovalUserService.level1['level']
          obb['undertaking'] = JSON.stringify([])
          obb['branch'] = this.ApprovalUserService.level1['branch']
          obb['user_name'] = this.ebillUser.party_name;
          obb['field_value'] = 0



          let resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.pendingapproval()



            await this.ChangeStatus(this.Obj['file_id'], status, obb)

            // else if (this.eng_Dept_flag == true) {

            //   await this.changedeptstatus(this.Obj['file_id'], status, obb)

            // }
            // await this.getallfiledata()

            this.spinner.hide();
            if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
              // obb['user_id'] = -1
              // obb['vendor_id'] = this.selectedTender['party_id']
              if (this.message_flag == true) {
                /* await this.getle(this.selectedTender['party_id']) */
              }

            } else {
              // if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'])

            }
            this.toastr.success("Approval Forwarded Successfully!!")
            console.log("Approval Forwarded Successfully!!")
          } else {
            this.spinner.hide();
            console.log(resp['data'])
            this.isResponseReceived = false;
            // this.toastr.errorToastr(resp['data'])
          }
        } else {
          this.isResponseReceived = false;
          // this.toastr.errorToastr("Please Select Any User..!")
          this.spinner.hide();
        }
      }
      else {
        this.spinner.show()
        if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
          var obb: any = new Object();
          if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            obb['user_id'] = -1
            if (this.Obj['party_id'] == null || this.Obj['party_id'] == undefined) {
              Swal.fire("Error", "Please Map Verdor with Work..!", 'error');
              return
            }
            obb['vendor_id'] = this.Obj['party_id']
          } else {
            obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
          }
          if (obb["user_id"] == -1) {
            let userData: any = {};
            userData['b_acct_id'] = this.b_acct_id;
            userData['user_id'] = obb["vendor_id"];
            let venderInfo = await this.mainserviceEmb.getVenderName(JSON.stringify(obb));
            if (venderInfo["error"] == false) {
              obb['user_name'] = venderInfo["data"]['party_leagal_name']
            }
          } else {
            for (let i = 0; i < this.ApprovalUserService.workuser.length; i++) {
              if (this.ApprovalUserService.workuser[i]['user_id'] == obb["user_id"]) {
                let h = this.ApprovalUserService.workuser[i]['desc'].split("-");
                obb['user_name'] = h[1];
              }
            }
          }


          obb['doc_local_no'] = this.Obj['doc_local_no']
          obb['doc_desc'] = this.Obj['doc_desc']
          obb['node_cd'] = this.Obj['node_cd']



          obb['b_acct_id'] = this.ebillUser.b_acct_id
          obb['forwarded_by'] = this.ebillUser.user_id
          obb['forward_msg'] = this.remark_note
          obb['remark'] = ""
          obb['status'] = 'PENDING'
          obb['doc_type'] = this.Obj['doc_type']//'EBILL'
          // obb['doc_local_no'] = this.tender_apprdata['doc_local_no']
          // obb['doc_desc'] = this.tender_apprdata['doc_desc']
          obb['undertaking'] = this.Obj['undertaking']
          obb['module_cd'] = this.Obj['module_cd'] //'EMB'
          // obb['node_cd'] = this.tender_apprdata['node_cd']
          if (this.ApprovalUserService.vendorflag == true) {
            obb['level'] = this.Obj['level']
            obb['branch'] = this.Obj['branch']
          }
          else {
            obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
            obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
            obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
          }

          obb['field_value'] = this.Obj['field_value']

          var resp = await this.mainserviceEmb.insertTask(obb)
          if (resp['error'] == false) {
            await this.aftersentpendingapproval()
            await this.underapprovalapproval(this.Obj)
            await this.ChangeStatus(this.Obj['file_id'], status, obb)
            if (this.ApprovalUserService.conditionflag == true) await this.approvedocmentwithcondition()

            // if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
            //   if (this.message_flag == true) await this.getle(this.selectedTender['party_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])
            // } else {
            //   if (this.message_flag == true) await this.getle(this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id'], this.ApprovalUserService.userObj[this.erpUser.le_id])

            // }
            this.spinner.hide();
            if (this.ApprovalUserService.conditionflag == false) {
              // m_avinash


              // $('#myModal2').modal('hide');


              Swal.fire("Success", "Approval Forwarded Successfully!!", 'success');

            }

          } else {
            this.spinner.hide();
            Swal.fire("Error", resp['data'], 'error');

          }
        } else {
          Swal.fire("Error", "Please Select Any User..!", 'error');

          this.spinner.hide();
        }
      }
    }



  }

  async underapprovalapproval(element: any) {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['status'] = 'UNDERAPPROVAL'
    obb['module_cd'] = this.Obj['module_cd']
    obb['doc_type'] = this.Obj['doc_type']
    obb['doc_local_no'] = this.Obj['doc_local_no']
    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');

    }

  }

  async aftersentpendingapproval() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['remark'] = this.remark_note //this.appr_remark
    obb['status'] = 'VERIFYED'
    obb['language'] = this.editorService.language
    obb['id'] = this.Obj['id']
    obb['doc_type'] = this.Obj['doc_type']
    obb['undertaking'] = this.Obj['undertaking'] ? this.Obj['undertaking'] : JSON.stringify([])


    if (this.editorService.language == 'Hindi') {
      obb['language'] = 'Hindi'
    } else {
      obb['language'] = 'English'
    }


    var resp = await this.portalmainservice.updatetask(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
    } else {
      this.spinner.hide();
      Swal.fire("Error", resp['data'], 'error');
    }
  }
  remark_note: any = null
  async ChangeStatus(id: any, status: any, obb: any) {
    let data = new FormData()
    let obj = Object()
    obj['b_acct_id'] = this.b_acct_id;
    obj['status'] = 'VERIFYED';
    obj['file_id'] = id
    obj["user_id"] = this.ebillUser.user_id
    obj["department"] = obb["doc_type"]
    obj["node_cd"] = obb["node_cd"]
    // obj['role_cd'] = obj['role_cd']
    if (this.ApprovalUserService.rolebyid.length > 0) {

      obj['role_user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
    }
    if (this.role) {

      obj["forwared_by"] = this.role
    }
    obj["description"] = "Bill Verify by Accountant"

    obj['description'] = this.remark_note
    obj["lang"] = this.editorService.language
    obj["role_cd"] = this.role

    // obj["supportive_doc"] = this.NocObj['supportive_doc']
    data.append('data', JSON.stringify(obj))
    console.log(obj);

    this.spinner.show();
    let resp = await this.clerkNocService.changefilestatus(obj)
    // let resp = await this.clerknocservice.changedeptstatus(data)

    if (resp['error'] == false) {
      this.spinner.hide();
      console.log('Successfully Chaged to ' + status)
      this.list_flag = true
      this.create_flag = false
      this.page_flag = true


      await this.back();
      await this.getallpaymentdata();

    }
    else {
      this.spinner.hide();
      this.toastr.error(resp['data']);
    }
  }


  async pendingapproval() {
    this.spinner.show()
    if (this.forwarded_user_id != null || this.ApprovalUserService.vendorflag == true) {
      let obb: any = new Object();
      if (this.forwarded_user_id == null && this.ApprovalUserService.vendorflag == true) {
      } else {
        obb['user_id'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']
        obb['user_name'] = this.ApprovalUserService.userObj[this.ApprovalUserService.rolebyid[this.forwarded_user_id]['user_id']]
      }

      console.log(this.forwarded_user_id)
      obb['b_acct_id'] = this.ebillUser.b_acct_id
      obb['forwarded_by'] = this.ebillUser.user_id
      obb['forward_msg'] = this.appr_remark
      obb['remark'] = this.appr_remark


      obb['status'] = 'PENDING'

      obb['doc_type'] = 'ACCOUNTANT'
      // status = 'ASSINGED_AE'


      obb['doc_local_no'] = this.Obj['file_id']
      obb['doc_desc'] = `This Filid NO ${this.Obj['file_id']} Is Assigned to CTP`
      obb['module_cd'] = 'NOC'
      obb['node_cd'] = this.Obj['node_cd']
      obb['undertaking'] = JSON.stringify([])
      if (this.ApprovalUserService.vendorflag == true) {
        obb['level'] = this.Obj['level']
        obb['branch'] = this.Obj['branch']
      }
      else {
        obb['role_cd'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['role_cd']
        obb['level'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['level']
        obb['branch'] = this.ApprovalUserService.rolebyid[this.forwarded_user_id]['branch']
      }
      obb['field_value'] = 0
      // var resp = await this.portalmainservice.updatetask(obb)
      let resp = await this.mainserviceEmb.insertTask(obb)
      if (resp['error'] == false) {

        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    } else {
      this.spinner.hide();
    }
  }

  lastlevelappr() {

  }

  async approvedocmentwithcondition() {
    this.spinner.show()
    var obb: any = new Object();
    obb['b_acct_id'] = this.ebillUser.b_acct_id
    obb['module_cd'] = this.Obj['module_cd']
    obb['status'] = 'VERIFYED'
    obb['doc_type'] = this.Obj['doc_type']
    obb['doc_local_no'] = this.Obj['doc_local_no']

    var resp = await this.portalmainservice.updateWorkflowDocumentStatus(obb)
    if (resp['error'] == false) {
      this.spinner.hide();
      Swal.fire("Success", "Approved Successfully!!", 'success');
    } else {
      this.spinner.hide();

      Swal.fire("Error", resp['data'], 'error');

    }

  }






  /////////////////////////////////excel export///////////////////////////////////////////


  export() {
    const dataToExport = this.datasource.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,
      'Date': moment(row.bill_date).format('DD/MM/YYYY'),
      'Transaction ID': row.txn_id,
      'Amount': row.bill_amount,
      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'Transaction_Data');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }



  export_verifyed() {
    const dataToExport = this.datasource_verfyed.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,
      'Date': moment(row.bill_date).format('DD/MM/YYYY'),
      'Transaction ID': row.txn_id,
      'Bill Amount': row.registration_amount,
      'Status': row.life_cycle_status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'Transaction_Data');
  }


}
